<div class="container">

  <button class="back-button p-button p-button-primary p-button-sm" (click)="goBack()">
    <i class="ri-arrow-left-s-line"></i>
    <span i18n="@@backToMapButton">Back to Map</span>
  </button>

  <app-user-menu></app-user-menu>

  <div class="content">

    <div class="header-container">
      <h2 i18n="@@eodIncidentReportTitle">EOD Incident Report</h2>
    </div>

    <div class="panel-container">

      <div class="button-container">

        <button
          pButton
          label="View HERO Report"
          i18n-label="@@viewHeroReportButton"
          [outlined]="true"
          class="p-button-sm"
          (click)="viewHeroReport()">
        </button>

        <button
          *ngIf="canDeleteEod"
          pButton
          label="Delete EOD Report"
          i18n-label="@@deleteEodReportButton"
          class="p-button-sm p-button-danger"
          (click)="deleteIncidentReport()">
        </button>

      </div>

      <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

        <!-- TAB 0: Initial Information -->
        <p-tabPanel header="Initial Information" i18n-header="@@initialInformationTab" [disabled]="isTabDisabled(0)">

          <div *ngIf="currentlyEditingTab === 0; else initialViewMode">

            <div style="max-width: 500px;">

              <form [formGroup]="initialForm">

                <app-incident-report-step1
                  [formGroup]="initialForm"
                  [heroReport]="heroReport">
                </app-incident-report-step1>

                <div style="display: flex; justify-content: space-between; margin-top: 1rem;">

                  <button
                    pButton
                    label="Cancel"
                    i18n-label="@@cancelButton"
                    class="p-button-sm p-button-text"
                    type="button"
                    (click)="cancelEdit(0)">
                  </button>

                  <button
                    pButton
                    label="Save"
                    i18n-label="@@saveButton"
                    class="p-button-sm p-button-primary"
                    type="button"
                    (click)="saveTab(0)">
                  </button>

                </div>

              </form>

            </div>

          </div>

          <ng-template #initialViewMode>

            <app-input-display-grid
              [values]="initialInformation"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem; text-align: right;">

              <button
                *ngIf="canEditEod"
                pButton
                icon="ri-pencil-line"
                class="p-button-sm p-button-primary"
                label="Edit"
                i18n-label="@@editButton"
                type="button"
                (click)="editTab(0)">
              </button>

            </div>

          </ng-template>

        </p-tabPanel>

        <!-- TAB 1: Action by EOD -->
        <p-tabPanel header="Action by EOD" i18n-header="@@actionByEodTab" [disabled]="isTabDisabled(1)">

          <div *ngIf="currentlyEditingTab === 1; else actionViewMode">

            <div style="max-width: 500px;">

              <form [formGroup]="actionForm">

                <app-incident-report-step2
                  [formGroup]="actionForm"
                  [deleteable]="false">
                </app-incident-report-step2>

                <div style="display: flex; justify-content: space-between; margin-top: 1rem;">

                  <button
                    pButton
                    label="Cancel"
                    i18n-label="@@cancelButton"
                    class="p-button-sm p-button-text"
                    type="button"
                    (click)="cancelEdit(1)">
                  </button>

                  <button
                    pButton
                    label="Save"
                    i18n-label="@@saveButton"
                    class="p-button-sm p-button-primary"
                    type="button"
                    (click)="saveTab(1)">
                  </button>

                </div>

              </form>

            </div>

          </div>

          <ng-template #actionViewMode>

            <app-input-display-grid
              [values]="actionInformation"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem;">

              <app-display-images [images]="images"></app-display-images>

            </div>

            <app-input-display-grid
              [values]="dimensions"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem; text-align: right;">

              <button
                *ngIf="canEditEod"
                pButton
                icon="ri-pencil-line"
                class="p-button-sm p-button-primary"
                label="Edit"
                i18n-label="@@editButton"
                type="button"
                (click)="editTab(1)">
              </button>

            </div>

          </ng-template>

        </p-tabPanel>

      </p-tabView>

    </div>

  </div>

</div>